import * as QuotesActionCreator from "./QuoteActionCreator";

export function defaultQuotesListState() {
    return {
        loading: false,
        response: null,
        error: null,
        page: 0,
        size: 10
    }
}

export const QuotesListReducer = (state,action) =>{
    if(!state || 
        action.type === QuotesActionCreator.QUOTES_ACTION.RESET_QUOTES_LIST_STATE
    ) {
        return {...state, ...defaultQuotesListState()};
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.REQUEST_QUOTES_LIST) {
       return { ...state, loading: true, page: action.data.page, size: action.data.size }
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.RESPONSE_QUOTES_LIST) {
        return { ...state, response: action.data, loading: false}
    }
     
    if(action.type === QuotesActionCreator.QUOTES_ACTION.ERROR_QUOTES_LIST) {
        return { ...state, error: action.data, loading: false }
    }

    return state;
}

export function defaultAddQuoteState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const AddQuoteReducer = (state,action) =>{
    if(!state || 
        action.type === QuotesActionCreator.QUOTES_ACTION.RESET_ADD_QUOTE_STATE
    ) {
        return {...state, ...defaultAddQuoteState()};
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.REQUEST_ADD_QUOTE) {
       return { ...state, loading: true}
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.RESPONSE_ADD_QUOTE) {
        return { ...state, response: action.data, loading: false}
    }
     
    if(action.type === QuotesActionCreator.QUOTES_ACTION.ERROR_ADD_QUOTE) {
        return { ...state, error: action.data, loading: false }
    }

    return state;
}

export function defaultEditQuoteState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const EditQuoteReducer = (state,action) =>{
    if(!state || 
        action.type === QuotesActionCreator.QUOTES_ACTION.RESET_EDIT_QUOTE_STATE
    ) {
        return {...state, ...defaultEditQuoteState()};
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.REQUEST_EDIT_QUOTE) {
       return { ...state, loading: true}
    }

    if (action.type === QuotesActionCreator.QUOTES_ACTION.RESPONSE_EDIT_QUOTE) {
        return { ...state, response: action.data, loading: false}
    }
     
    if(action.type === QuotesActionCreator.QUOTES_ACTION.ERROR_EDIT_QUOTE) {
        return { ...state, error: action.data, loading: false }
    }

    return state;
}

export function defaultQuoteById() {
    return { 
      loading: false,
      response: null,
      error: null,
    };
  }
 
  export const QuoteByIdReducer = (state, action) => {
    if (
      !state ||
      action.type === QuotesActionCreator.QUOTES_ACTION.RESET_QUOTE_BY_ID_STATE
    ) {
      return { ...state, ...defaultQuoteById() };
    }
  
    if (action.type === QuotesActionCreator.QUOTES_ACTION.REQUEST_QUOTE_BY_ID) {
      return { ...state, loading: true };
    }
  
    if (action.type === QuotesActionCreator.QUOTES_ACTION.RESPONSE_QUOTE_BY_ID) {
      return { ...state, response:action.data , loading: false };
    }
  
    if (action.type === QuotesActionCreator.QUOTES_ACTION.ERROR_QUOTE_BY_ID) {
      return { ...state, error: action.data, loading: false };
    }
  
    return state; 
  };